// extracted by mini-css-extract-plugin
export var contrastLow = "_m-1";
export var externalLink = "_m-2";
export var externalLinkIcon = "_m-3";
export var link = "_m-0";
export var linkLabel = "_m-4";